import {
    formatJsDate,
    getCurrentDate,
    formatINRCurrency,
  } from "../../common/utils"

export const getTotalAmount = (response) =>{
    const A = response?.openingBalance
    const B = response?.netWeddingzServiceFee?.amount
    const C = response?.pastBookingsImpact?.amount
    const D = response?.reconPaymentSection?.amount
    return formatINRCurrency(A + B + C + D)
}

export const mapGetReceivableByMonthyIdResponse = (response) =>{
    //mapping of api response 

    return {
        totalAmount: getTotalAmount(response),
        openingBalance: formatINRCurrency(response?.openingBalance),
        netWeddingzServiceFee: formatINRCurrency(response?.netWeddingzServiceFee?.amount),
        pastBookingsImpact: formatINRCurrency(response?.pastBookingsImpact?.amount),
        reconPaymentSection: formatINRCurrency(response?.reconPaymentSection?.amount),
        paidByDate: getCurrentDate("DD MMMM yyyy"),
    }
}

